import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fe0ec97&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0ec97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe0ec97')) {
      api.createRecord('2fe0ec97', component.options)
    } else {
      api.reload('2fe0ec97', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fe0ec97&scoped=true&", function () {
      api.rerender('2fe0ec97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Promotion/index.vue"
export default component.exports